module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin u-full-width flex-grid--wrap u-flex-center"
  }, [_c('div', {
    staticClass: "p-compare-reserve__average-diff-chart"
  }, [_c('h2', {
    staticClass: "u-centre chart"
  }, [_vm._v("Average Difference between " + _vm._s(_vm.fromLabel) + " and " + _vm._s(_vm.toLabel))]), _vm._v(" "), (_vm.theCurrentWidth >= 600) ? _c('bar-chart', {
    attrs: {
      "chart-data": _vm.currentChartData,
      "options": _vm.defaultOptions,
      "height": 200
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('difference-table', {
    attrs: {
      "average-from": _vm.averageFrom,
      "average-to": _vm.averageTo,
      "difference": _vm.averageDifference,
      "from-label": _vm.fromLabel,
      "to-label": _vm.toLabel,
      "colours": _vm.colours
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-413b22a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/DifferenceChart.vue
// module id = 1659
// module chunks = 0